import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './ClientTestimonial.css';

import expertImg1 from '../assets/images/expert1.png';
import expertImg2 from '../assets/images/expert2.png';
import expertImg3 from '../assets/images/expert3.png';

const fallbackData = [
  {
    name: 'Willium Smith',
    image: expertImg1,
    position: 'CEO & Co-Founder',
    social_links: {
      facebook: '#',
      twitter: '#',
      instagram: '#',
    },
  },
  {
    name: 'Jane Doe',
    image: expertImg2,
    position: 'Finance Expert',
    social_links: {
      facebook: '#',
      twitter: '#',
      instagram: '#',
    },
  },
  {
    name: 'John Doe',
    image: expertImg3,
    position: 'CTO & Co-Founder',
    social_links: {
      facebook: '#',
      twitter: '#',
      instagram: '#',
    },
  },
];

const StorytTestimonial = ({ teamMembers }) => {
  const sliderItems = teamMembers?.length > 0 ? teamMembers : fallbackData;

  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    arrows: true,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const CustomPrevArrow = (props) => (
    <button {...props} className="slick-prev custom-arrow" aria-label="Previous">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" fill="currentColor" />
      </svg>
    </button>
  );

  const CustomNextArrow = (props) => (
    <button {...props} className="slick-next custom-arrow" aria-label="Next">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <path d="M8.59 16.59L10 18l6-6-6-6-1.41 1.41L13.17 12z" fill="currentColor" />
      </svg>
    </button>
  );

  return (
    <div className="testimonial-slider">
      <Slider {...settings} prevArrow={<CustomPrevArrow />} nextArrow={<CustomNextArrow />}>
        {sliderItems.map((item, index) => (
          <div className="item" key={index}>
            <div className="expert-content">
              <img src={item.image} alt={item.name} />
              <div className="expert-name">
                <h5 className="mb-0">{item.name}</h5>
                <p className="mb-0">{item.position}</p>
                <div className="expert-icons">
                  <ul>
                    <li><a href={item.social_links?.facebook} target="_blank" rel="noreferrer"><i className="fa-brands fa-facebook-f"></i></a></li>
                    <li><a href={item.social_links?.twitter} target="_blank" rel="noreferrer"><i className="fa-brands fa-x-twitter"></i></a></li>
                    <li><a href={item.social_links?.instagram} target="_blank" rel="noreferrer"><i className="fa-brands fa-instagram"></i></a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default StorytTestimonial;